/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createAtan } from '../../factoriesAny.js';
export var atanDependencies = {
  typedDependencies: typedDependencies,
  createAtan: createAtan
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAtan.generated.js
// module id = 487
// module chunks = 0